import { Box, Stack, Tab, Tabs as MUITabs } from '@mui/material'
import React, { useState } from 'react'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      {...other}>
      {value === index && <Box sx={{}}>{children}</Box>}
    </div>
  )
}

interface Props {
  tabTitles: string[]
  tabItems: JSX.Element[]
  testId?: string
  itemsRight?: JSX.Element
}

export const Tabs: React.FC<Props> = ({
  tabTitles,
  tabItems,
  testId,
  itemsRight
}) => {
  const [selectedTab, setSelectedTab] = useState(0)

  const handleChange = (e: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue)
  }
  return (
    <Box sx={{ width: '100%' }} data-testid={testId}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <MUITabs
          value={selectedTab}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto">
          {tabTitles.map((title, index) => (
            <Tab
              data-testid={`tabButton-${index.toString()}`}
              key={title}
              label={title}
              sx={{ textTransform: 'none' }}
            />
          ))}
        </MUITabs>
        {selectedTab === 1 && itemsRight}
      </Stack>
      {tabItems.map((item: JSX.Element, index) => (
        <TabPanel key={index.toString()} value={selectedTab} index={index}>
          {item}
        </TabPanel>
      ))}
    </Box>
  )
}
